<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "SalesForceOpportunityBilling",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  